module.exports = __webpack_public_path__ + "img/空白（页码+静态文字）.e1f7b4af.png";